const getSwatches = state => state.facet.swatches;

export default getSwatches;
